import {
  AppDetailed,
  BrandLocationFieldConfig,
  BrandProperty,
  EcomAssortment,
  LocationProperty,
  RegionV2,
  RoleDetailed,
} from '../commonTypes';

/**
 * @deprecated replaced by @RoleDetailed
 */
export interface RoleBrandView {
  isAdmin: boolean;
  key: string;
  motimateRole: boolean;
  selfAssign: boolean;
  title: string;
}

export interface AvailableProps {
  availableBrandRoles: RoleBrandView[];
  availableDataownerRoles: RoleBrandView[];
  availableLocationRoles: RoleBrandView[];
  availableEcomAssortments: EcomAssortment[];
}

export interface BrandV2 {
  uuid: string | null;
  name: string;
  key: string;
  mgParticipantType: MgParticipantType;
  country: string;
  updatedAt: string | null;
  updatedBy: string | null;
  locationRoles: Array<RoleDetailed>;
  dataownerRoles: Array<RoleDetailed>;
  brandRoles: Array<RoleDetailed>;
  regions: Array<RegionV2>;
  brandLocationFieldConfigs: Array<BrandLocationFieldConfig>;
  employeePortalClientId: string | null;
  locationProperties: Array<LocationProperty>;
  ecommerceAssortments: Array<EcomAssortment>;
  apps: Array<AppDetailed>;
  isAdmin: boolean;
  properties: Array<BrandProperty>;
  externalIds: Array<BrandProperty>;
}

export enum MgParticipantType {
  MEMBER = 'MEMBER',
  SUPPLIER = 'SUPPLIER',
}

export interface BrandBasic {
  uuid: string;
  name: string;
  key: string;
}

export interface PatchBrandAppDTO {
  appKey: string;
  default: boolean;
  name?: string;
  url?: string | null;
}

export interface PatchBrandDTO {
  brandApps?: PatchBrandAppDTO[];
  brandRoles?: string[];
  dataownerRoles?: string[];
  locationRoles?: string[];
  ecomAssortmentKeys?: string[];
  employeePortalClientId?: string;
  memberFrom?: string;
  memberTo?: string;
  name?: string;
}

export interface UpdateRegionDTO {
  key?: string;
  name?: string;
  postFix?: string;
}

export interface CreateBrandDTO {
  name: string;
  country: string;
  mgParticipantType: MgParticipantType;
}
